import { ConfigurationDTO, ConfigurationUrlsDTO } from '../swagger-api-v1';
import FeaturesEnum = ConfigurationDTO.FeaturesEnum;
import BusinessModelEnum = ConfigurationDTO.BusinessModelEnum;

export enum BusinessModel {
  B2C = 'B2C',
  B2B = 'B2B'
}

interface UpdateInterval {
  startDateTime: number;
  endDateTime: number;
}

interface FeatureFlags {
  blockingHistory: boolean;
  userRoles: boolean;
  geoFencing: boolean;
  networkStatistics: boolean;
}

interface Urls {
  appStore: string;
  googlePlay: string;
  windowsStore: string;
  OSXAppStore: string;
  childProtectionAppStore: string;
  childProtectionGooglePlay: string;
  termsAndConditions: string;
  eula: string;
  gdpr: string;
}

export class AppConfig {
  constructor(
    public urls: Urls,
    public updateInterval: UpdateInterval,
    public features: FeatureFlags,
    public eulaAcceptanceNeeded: boolean,
    public businessModel: BusinessModel
  ) {}

  public static fromDTO(dto: ConfigurationDTO): AppConfig {
    return new AppConfig(
      AppConfig.getUrls(dto.urls),
      {
        startDateTime: dto.updateInterval.startDateTime * 1000,
        endDateTime: dto.updateInterval.endDateTime * 1000
      },
      AppConfig.getFeatureFlags(dto.features),
      dto.eulaAcceptanceNeeded,
      // Default business model is not used, it's only present for legacy reasons it should be ignored
      dto.businessModel === BusinessModelEnum.B2B ? BusinessModel.B2B : BusinessModel.B2C
    );
  }

  private static getFeatureFlags(features: FeaturesEnum[]): FeatureFlags {
    return {
      blockingHistory: !features.includes(FeaturesEnum.DISABLE_BLOCKING_HISTORY),
      userRoles: features.includes(FeaturesEnum.ENABLE_USER_ROLES),
      geoFencing: features.includes(FeaturesEnum.ENABLE_GEOFENCING),
      networkStatistics: !features.includes(FeaturesEnum.DISABLE_DASHBOARD_NETWORK_STATISTICS)
    } as FeatureFlags;
  }

  private static getUrls(urls: ConfigurationUrlsDTO): Urls {
    return {
      appStore: urls.appStore,
      googlePlay: urls.googlePlay,
      windowsStore: urls.windowsStore,
      OSXAppStore: urls.macOsStore,
      childProtectionAppStore: urls.childProtectionAppStore,
      childProtectionGooglePlay: urls.childProtectionGooglePlay,
      termsAndConditions: urls.termsAndCondition,
      eula: urls.eula,
      gdpr: urls.gdpr
    } as Urls;
  }
}
